import { gql } from "apollo-boost";

export const FrFundraisers = gql`
  query ($filter: FundraiserFilter) {
    fundraisers(filter: $filter) {
      total
      avgApprovalTime
      items {
        id
        type
        name
        createDate
        start
        end
        state
        shareCode
        orgId
        funOrgId
        perGoal {
          singular
          plural
          description
          minimum
        }
        suggestions {
          label
          amount
        }
        target
        title
        description
        count
        proceeds
        status
        org {
          id
          name
        }
        funOrg {
          id
          name
        }
      }
    }
  }
`;

export const FrFundraiser = gql`
  query fundraiser($id: String!) {
    fundraiser(id: $id) {
      id
      type
      name
      createDate
      start
      end
      complete
      state
      shareCode
      status
      orgId
      funOrgId
      perGoal {
        singular
        plural
        description
        minimum
      }
      donates {
        id
        createDate
        user {
          id
          name
        }
        child {
          id
          name
        }
        goal
        amount
        count
        inviteName
      }
      perGoalDonates {
        id
        childId
        user {
          id
          name
        }
        child {
          id
          name
        }
        amount
        count
      }
      suggestions {
        label
        amount
      }
      target
      title
      description
      count
      proceeds
      org {
        id
        name
      }
      funOrg {
        id
        name
      }
    }
  }
`;

export const saveFundraising = gql`
  mutation saveFundraising($input: FrFundraiserInput!) {
    saveFundraising(input: $input)
  }
`;

export const saveFundPerGoalResult = gql`
  mutation saveFundPerGoalResult($id: String!, $items: [SaveFundPerGoalItem!]!) {
    saveFundPerGoalResult(id: $id, items: $items)
  }
`;

export const acceptFundraising = gql`
  mutation acceptFundraising($id: String!) {
    acceptFundraising(id: $id)
  }
`;

export const rejectFundraising = gql`
  mutation rejectFundraising($id: String!) {
    rejectFundraising(id: $id)
  }
`;

export const SaveFundCommunities = gql`
  mutation saveFundCommunities($id: String!, $communities: [String!]!) {
    saveFundCommunities(id: $id, communities: $communities)
  }
`;

export const completeFundPerGoalByEmployee = gql`
  mutation completeFundPerGoalByEmployee($id: String!) {
    completeFundPerGoalByEmployee(id: $id)
  }
`;

const exportDonates = gql`
  query exportDonates($id: String!) {
    exportDonates(id: $id) {
      filename
      data
    }
  }
`;

export const frFunGql = {
  FrFundraisers,
  FrFundraiser,
  saveFundraising,
  saveFundPerGoalResult,
  acceptFundraising,
  rejectFundraising,
  completeFundPerGoalByEmployee,
  exportDonates,
};
